

















import { Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class AvatarSelect extends Vue {
    @Prop({ required: true }) readonly value: string

    avatarSrc(type: string): string {
        return require('@/assets/img/avatar/avatar' + type + '.jpg')
    }

    emitValue(name: string) {
        this.$emit('input', name)
    }

    get avatars() {
        return [
            {
                type: '1',
                name: 'avatar1',
            },
            {
                type: '2',
                name: 'avatar2',
            },
            {
                type: '3',
                name: 'avatar3',
            },
            {
                type: '4',
                name: 'avatar4',
            },
            {
                type: '5',
                name: 'avatar5',
            },
        ]
    }
}
